// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const EditorBodyRoot = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const EditorTitle = styled.h3`
  margin-top: 1rem;
`;
